import { featureFlags } from '@seen/core/featureFlags'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import { IconCheckboxButton } from '@seen/ui'
import { IconInbox } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'
import { useRead } from '#src/hooks/useRead.ts'

export interface TaskInboxNotificationCheckboxProps {
  value: boolean
  onChange: (value: boolean) => void
  owner: string | null
}

export function TaskInboxNotificationCheckbox({
  value,
  onChange,
  owner,
}: TaskInboxNotificationCheckboxProps): JSX.Element | null {
  const enabled = useFeatureFlag(featureFlags.taskInboxNotificationOverride)
  const { data: ownerPractitioner } = useRead(
    ExtendedPractitioner,
    owner ?? undefined
  )

  if (!enabled) {
    return null
  }

  const label = ownerPractitioner
    ? `Send inbox notification to ${ownerPractitioner.name}`
    : 'Send inbox notification'

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconCheckboxButton
          icon={IconInbox}
          value={value}
          onChange={onChange}
          label={label}
        />
      </TooltipTrigger>
      <TooltipContent side="top">{label}</TooltipContent>
    </Tooltip>
  )
}
